import { render, staticRenderFns } from "./credentials.vue?vue&type=template&id=486bf6c4&scoped=true&"
import script from "./credentials.vue?vue&type=script&lang=js&"
export * from "./credentials.vue?vue&type=script&lang=js&"
import style0 from "./credentials.vue?vue&type=style&index=0&id=486bf6c4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "486bf6c4",
  null
  
)

export default component.exports